/* Richer "Your saved products" panel: thumbnail, brand, title, price / was-price, stock and
   Add to cart for each saved product. Patches the existing ict-saved-products element's render(),
   so saving, removing and the count keep working exactly as before. */
(function () {
  function money(cents) {
    var format = (window.theme && theme.settings && theme.settings.moneyFormat) || 'K{{amount_no_decimals}}';
    var value = cents / 100;
    function fmt(decimals, thousands, decimal) {
      var parts = value.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      if (key === 'amount_no_decimals') return fmt(0, ',', '.');
      if (key === 'amount_with_comma_separator') return fmt(2, '.', ',');
      if (key === 'amount_no_decimals_with_comma_separator') return fmt(0, '.', ',');
      return fmt(2, ',', '.');
    });
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function removeButton(handle, label) {
    var b = el('button', 'ict-sv__remove', '×');
    b.type = 'button';
    b.dataset.ictSave = handle;
    b.setAttribute('aria-label', label);
    return b;
  }

  function productRow(p, handle, root, removeLabel) {
    var url = root + 'products/' + encodeURIComponent(handle);
    var variant = (p.variants || []).find(function (v) { return v.available; }) || (p.variants || [])[0];
    var row = el('article', 'ict-sv');

    var media = el('a', 'ict-sv__media');
    media.href = url;
    media.setAttribute('aria-hidden', 'true');
    media.tabIndex = -1;
    if (p.featured_image) {
      var img = el('img');
      img.src = p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=240';
      img.alt = '';
      img.loading = 'lazy';
      media.append(img);
    }
    row.append(media);

    var body = el('div', 'ict-sv__body');
    if (p.vendor) body.append(el('small', 'ict-sv__vendor', p.vendor));
    var title = el('a', 'ict-sv__title', p.title);
    title.href = url;
    body.append(title);

    var price = el('div', 'ict-sv__price');
    if (p.price > 0) {
      var onSale = p.compare_at_price && p.compare_at_price > p.price;
      price.append(el('strong', onSale ? 'is-sale' : '', money(p.price)));
      if (onSale) {
        price.append(el('span', 'ict-sv__was', 'Was ' + money(p.compare_at_price)));
        price.append(el('em', 'ict-sv__save', 'Save ' + money(p.compare_at_price - p.price)));
      }
    } else {
      price.append(el('strong', 'is-call', 'Call for price'));
    }
    body.append(price);
    body.append(el('p', 'ict-sv__stock ' + (p.available ? 'is-in' : 'is-out'), p.available ? 'In stock' : 'Sold out'));
    row.append(body);

    var actions = el('div', 'ict-sv__actions');
    if (p.available && variant && p.price > 0) {
      var add = el('button', 'ict-sv__add', 'Add to cart');
      add.type = 'button';
      add.dataset.variantId = variant.id;
      actions.append(add);
    } else {
      var view = el('a', 'ict-sv__view', 'View');
      view.href = url;
      actions.append(view);
    }
    actions.append(removeButton(handle, removeLabel));
    row.append(actions);
    return row;
  }

  function missingRow(handle, removeLabel) {
    var row = el('article', 'ict-sv is-missing');
    row.append(el('div', 'ict-sv__media'));
    var body = el('div', 'ict-sv__body');
    body.append(el('span', 'ict-sv__title', handle.replace(/-/g, ' ')));
    body.append(el('p', 'ict-sv__stock is-out', 'No longer available'));
    row.append(body);
    var actions = el('div', 'ict-sv__actions');
    actions.append(removeButton(handle, removeLabel));
    row.append(actions);
    return row;
  }

  async function addToCart(button) {
    var label = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';
    try {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(button.dataset.variantId), quantity: 1 }] })
      });
      if (!res.ok) throw new Error('add failed');
      var cart = await (await fetch(root + 'cart.js')).json();
      document.querySelectorAll('cart-count').forEach(function (count) {
        var n = count.querySelector('[aria-hidden]') || count;
        n.textContent = cart.item_count;
        count.hidden = cart.item_count === 0;
      });
      // Re-render Concept's cart drawer so the new item is there when it's opened.
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false } }));
      button.textContent = 'Added ✓';
      button.classList.add('is-added');
    } catch (e) {
      button.textContent = label;
      button.disabled = false;
    }
  }

  function patch() {
    var Saved = customElements.get('ict-saved-products');
    if (!Saved || Saved.prototype.__ictEnhanced) return !!Saved;
    Saved.prototype.__ictEnhanced = true;
    Saved.prototype.render = async function () {
      var version = ++this.version;
      var self = this;
      this.list.replaceChildren();
      var message = el('p', 'ict-sv-empty', this.items.length ? this.dataset.loading : this.dataset.empty);
      this.list.append(message);
      if (!this.items.length) return;
      var root = this.dataset.root.endsWith('/') ? this.dataset.root : this.dataset.root + '/';
      var handles = this.items.slice();
      var rows = await Promise.all(handles.map(async function (handle) {
        try {
          var res = await fetch(root + 'products/' + encodeURIComponent(handle) + '.js');
          if (!res.ok) throw new Error('missing');
          return productRow(await res.json(), handle, root, self.dataset.remove);
        } catch (e) {
          return missingRow(handle, self.dataset.remove);
        }
      }));
      if (this.version !== version) return;
      var count = el('p', 'ict-sv-count', handles.length + (handles.length === 1 ? ' item' : ' items'));
      this.list.replaceChildren(count);
      rows.forEach(function (row) { self.list.append(row); });
      this.sync();
    };
    document.addEventListener('click', function (event) {
      var add = event.target.closest('.ict-sv__add');
      if (add && !add.disabled) addToCart(add);
    });
    return true;
  }

  if (!patch()) customElements.whenDefined('ict-saved-products').then(patch);
})();
